import { useState, useEffect } from 'react';
import { Common, color } from '@stockbit/ui';
import { useDispatch } from 'react-redux';
import { Col, Row } from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/router';

import {
  RegisterModal,
  Container,
  TitleBanner,
  Footer,
  CustomText,
  ColEmailButton,
  RowRegisterForm,
  LogoContainer,
  TitleForm,
  DividerText,
} from './styled';
import { RegisterButton } from '../styled';

import Image from 'global/Image';

import GoogleOauth from '../../register/GoogleOauth';
import FacebookOauth from '../../register/FacebookOauth';

import rootSlice from '../../register/slice';
import { formTypes } from '../../register/constants';

const { Modal, Text, Iconmoon, Flex, Button } = Common;

const getWindowSize = () => {
  if (typeof window === 'undefined') {
    return { width: 0, height: 0 };
  }

  const { clientWidth: width, clientHeight: height } = document.documentElement;
  return { width, height };
};

const GuestRegisterModal = ({
  isCompanyStock,
  visible,
  setVisible,
  features,
}) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const [windowSize, setWindowSize] = useState(getWindowSize());
  const isMobileView = windowSize.width < 600;
  const isTabletView = windowSize.width >= 600 && windowSize.width < 1024;
  const isLaptopView = windowSize.width >= 1024;
  const bannerWidth = isLaptopView ? 450 : 315;

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  const navigate = () => {
    if (!isMobileView) {
      dispatch(
        rootSlice.actions.changeForm({
          target: formTypes.EMAIL,
        }),
      );
    }

    router.push('/register');
  };

  const renderNonStockModal = () => (
    <Modal type="basic" visible={visible} onCancel={() => setVisible(!visible)}>
      <div style={{ padding: 30 }}>
        <Text as="span" family="bold" size="36px">
          Daftar{' '}
        </Text>
        <Text as="span" family="bold" size="36px" color={color.primary}>
          Gratis
        </Text>
        <Text as="p" family="bold" size="18px">
          dan dapatkan:
        </Text>
        <Flex direction="column" mt="30px" mb="30px">
          {features.map((f) => (
            <Flex align="center" padding="6px 0">
              <Iconmoon
                key={f.name}
                className={f.icon}
                size="24px"
                color={color.black}
              />
              <Text padding="0 0 0 10px" size="18px">
                {f.name}
              </Text>
            </Flex>
          ))}
          <Text color={color.midgray} size="10px" mt="5px">
            *) Gratis Coba 30 Hari
          </Text>
        </Flex>
        <Link href="/register">
          <RegisterButton>
            <Text color={color.light} size="20px" family="bold">
              Daftar Sekarang
            </Text>
          </RegisterButton>
        </Link>
      </div>
    </Modal>
  );

  const renderStockModal = () => {
    const imageBanner = isLaptopView
      ? '/images/pc-guest-banner.jpg'
      : isTabletView
      ? '/images/tablet-guest-banner.jpg'
      : '/images/mobile-guest-banner.jpg';
    const registerButtonText = isMobileView
      ? 'Daftar Sekarang'
      : 'Register with Email';

    return (
      <RegisterModal
        centered
        type="basic"
        width="100%"
        style={{
          maxWidth: isMobileView ? bannerWidth : bannerWidth * 2,
          paddingBottom: 0,
        }}
        visible={visible}
        onCancel={() => setVisible(!visible)}
      >
        <Row justify="space-between">
          <Col span={isMobileView ? 24 : 12}>
            <TitleBanner>
              <div className="title-banner">Daftar Stockbit Sekarang</div>
              <p>Gabung Komunitas Saham dan Dapatkan</p>
              <p>
                Berbagai <b>Fitur Pro GRATIS</b> Selama 30 Hari! 🚀
              </p>
            </TitleBanner>
            <Image
              alt="Register Sotckbit"
              src={imageBanner}
              style={{ width: bannerWidth }}
            />
            <ColEmailButton span={isMobileView ? 24 : 0}>
              <Button
                block
                round
                type="primary"
                onClick={navigate}
                height="44px"
                id="email-register"
              >
                <CustomText color="light" family="bold">
                  {registerButtonText}
                </CustomText>
              </Button>
            </ColEmailButton>
          </Col>
          <Col span={isMobileView ? 0 : 12}>
            <RowRegisterForm justify="space-between">
              <Container span={24}>
                <LogoContainer align="center" justify="center">
                  <Image src="/icon/stockbit-new.svg" alt="Sotckbit" />
                </LogoContainer>

                <Flex align="center" justify="center" margin="10% 0 8% 0">
                  <TitleForm>Welcome to Stockbit</TitleForm>
                </Flex>

                <GoogleOauth
                  isCompanyStock
                  variant="secondary"
                  size={isLaptopView ? 'large' : 'medium'}
                />
                <FacebookOauth
                  isCompanyStock
                  variant="secondary"
                  size={isLaptopView ? 'large' : 'medium'}
                />

                <DividerText plain>
                  <CustomText color="#B5B5B5" family="bold">
                    Or
                  </CustomText>
                </DividerText>

                <Button
                  block
                  round
                  mb="10%"
                  type="primary"
                  onClick={navigate}
                  height={`${isLaptopView ? 35 : 30.8}px`}
                  id="email-register"
                >
                  <CustomText color="light" family="bold">
                    {registerButtonText}
                  </CustomText>
                </Button>

                <CustomText align="center">
                  Already have a Stockbit account?{' '}
                  <Link href="/login">
                    <CustomText as="a" family="bold">
                      Login
                    </CustomText>
                  </Link>
                </CustomText>
              </Container>

              <Footer>
                <Flex align="center" justify="center">
                  <CustomText align="center">
                    By signing up you agree with our
                    <Link href="/terms">
                      <CustomText as="a"> Terms & Conditions.</CustomText>
                    </Link>
                  </CustomText>
                </Flex>
              </Footer>
            </RowRegisterForm>
          </Col>
        </Row>
      </RegisterModal>
    );
  };

  if (isCompanyStock) {
    return renderStockModal();
  } else {
    return renderNonStockModal();
  }
};

export default GuestRegisterModal;
